import { render, staticRenderFns } from "./PostFormButton.vue?vue&type=template&id=4cf98ad5&scoped=true"
import script from "./PostFormButton.vue?vue&type=script&lang=ts"
export * from "./PostFormButton.vue?vue&type=script&lang=ts"
import style0 from "./PostFormButton.vue?vue&type=style&index=0&id=4cf98ad5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf98ad5",
  null
  
)

export default component.exports